export const mascaraCNPJ = (cnpj) => {
  if (!cnpj) return '';
  const cleaned = cnpj.toString().replace(/\D/g, '');
  return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

export const mascaraTelefone = (telefone) => {
  if (!telefone) return '';
  const cleaned = telefone.toString().replace(/\D/g, '');
  return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};

export const mascaraValor = (valor) => {
  if (valor === null || valor === undefined) return '';
  return Number(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};
